import { jsxs, jsx } from 'react/jsx-runtime';
import { ErrorMessage } from '@promo-platform/error-message';
import { FieldHead } from '@promo-platform/field-head';
import { useConditionsWatch } from '@promo-platform/utils';
import classNames from 'classnames';
import { useState, useRef } from 'react';
import DatePicker from 'react-datepicker';
import { useFormContext, Controller } from 'react-hook-form';

const DateField = ({ alias, id, label, description, tooltip, tooltipLabel, mandatoryValidation, conditions, }) => {
    var _a;
    const { control, formState: { errors }, watch, } = useFormContext();
    const shouldRender = useConditionsWatch(watch, conditions);
    const [startDate, setStartDate] = useState(null);
    const datePickerRef = useRef(null);
    return shouldRender ? (jsxs("div", Object.assign({ className: classNames('pp-date-field', {
            'pp-date-field--error': Boolean(errors === null || errors === void 0 ? void 0 : errors[alias]),
        }) }, { children: [jsx(FieldHead, { id: id, label: label, description: description, tooltipText: tooltip, tooltipLabel: tooltipLabel }), jsx(Controller, { name: alias, control: control, rules: {
                    required: mandatoryValidation && mandatoryValidation.errorMessage,
                }, shouldUnregister: true, render: ({ field: { onChange, onBlur } }) => (jsx(DatePicker, Object.assign({ className: "react-datepicker__input", selected: startDate, placeholderText: "DD/MM/YYYY", dateFormat: "dd/MM/yyyy", showMonthDropdown: true, useShortMonthInDropdown: true, showYearDropdown: true, yearDropdownItemNumber: 6, dropdownMode: "scroll", onBlur: onBlur, onChange: (date) => {
                        onChange(date);
                        setStartDate(date);
                    }, ref: datePickerRef }, { children: jsx("div", Object.assign({ className: "react-datepicker__close-button-wrapper" }, { children: jsx("button", { className: "react-datepicker__close-button", type: "button", "aria-label": "close", onClick: () => {
                                var _a;
                                if (datePickerRef.current !== null) {
                                    (_a = datePickerRef === null || datePickerRef === void 0 ? void 0 : datePickerRef.current) === null || _a === void 0 ? void 0 : _a.setOpen(false);
                                }
                            } }) })) }))) }), jsx(ErrorMessage, { message: (_a = errors[alias]) === null || _a === void 0 ? void 0 : _a.message })] }))) : null;
};

export { DateField };
